export default __webpack_public_path__ + "static/media/3.fd4a946f.png";